export const FIND_TABLE_ENTRIES_FAILURE = 'FIND_TABLE_ENTRIES_FAILURE';

export const findTableEntriesFailure = error => ({
    type: FIND_TABLE_ENTRIES_FAILURE,
    payload: error,
    error: true,
});
